if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.prevButton = this.querySelector('[data-lightbox-prev]');
        this.nextButton = this.querySelector('[data-lightbox-next]');

        this.currentCounter = this.querySelector('[data-lightbox-current]');
        this.totalCounter = this.querySelector('[data-lightbox-total]');

        this.prevButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.previousMedia();
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.nextMedia();
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.previousMedia();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.nextMedia();
          }
        });

        this.addEventListener(
          'touchstart',
          (event) => {
            if (!this.hasAttribute('open')) return;

            const touch = event.changedTouches[0];

            this.touchStartX = touch.clientX;
            this.touchStartY = touch.clientY;
          },
          { passive: true }
        );

        this.addEventListener(
          'touchend',
          (event) => {
            if (!this.hasAttribute('open')) return;

            const touch = event.changedTouches[0];

            const diffX = touch.clientX - this.touchStartX;
            const diffY = touch.clientY - this.touchStartY;

            /*
             * Dikey scroll hareketini swipe olarak algılama.
             */
            if (Math.abs(diffY) > Math.abs(diffX)) return;

            /*
             * Çok küçük parmak hareketlerini yok say.
             */
            if (Math.abs(diffX) < 50) return;

            if (diffX < 0) {
              this.nextMedia();
            } else {
              this.previousMedia();
            }
          },
          { passive: true }
        );
      }

      get mediaItems() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content > [data-media-id]'
          )
        ).filter((item) => {
          return !item.classList.contains('product__media-item--variant');
        });
      }

      hide() {
        this.pauseCurrentMedia();

        super.hide();
      }

      show(opener) {
        super.show(opener);

        const mediaId = opener?.getAttribute('data-media-id');

        const items = this.mediaItems;

        let index = items.findIndex(
          (item) => item.getAttribute('data-media-id') === mediaId
        );

        if (index < 0) {
          index = 0;
        }

        this.showMedia(index, false);
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');

        const items = this.mediaItems;

        let index = items.findIndex(
          (item) => item.getAttribute('data-media-id') === mediaId
        );

        if (index < 0) {
          index = 0;
        }

        this.showMedia(index, false);
      }

      showMedia(index, animate = true) {
        const items = this.mediaItems;

        if (!items.length) return;

        /*
         * Sonsuz döngü:
         * son görselden sonra ilk görsel,
         * ilk görselden geriye gidince son görsel.
         */
        if (index >= items.length) {
          index = 0;
        }

        if (index < 0) {
          index = items.length - 1;
        }

        this.pauseCurrentMedia();

        items.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-hidden', 'true');
        });

        const activeMedia = items[index];

        if (!activeMedia) return;

        this.currentIndex = index;

        activeMedia.classList.add('active');
        activeMedia.setAttribute('aria-hidden', 'false');

        /*
         * YouTube / video / model gibi deferred media varsa
         * gerektiğinde yükle.
         */
        const template = activeMedia.querySelector('template');

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          template
        ) {
          activeMedia.loadContent?.();
        }

        this.updateCounter();

        /*
         * Küçük geçiş animasyonu.
         */
        if (animate) {
          activeMedia.classList.remove('lightbox-media-enter');

          requestAnimationFrame(() => {
            activeMedia.classList.add('lightbox-media-enter');
          });
        }
      }

      nextMedia() {
        this.showMedia(this.currentIndex + 1);
      }

      previousMedia() {
        this.showMedia(this.currentIndex - 1);
      }

      updateCounter() {
        const total = this.mediaItems.length;

        if (this.currentCounter) {
          this.currentCounter.textContent = String(
            this.currentIndex + 1
          );
        }

        if (this.totalCounter) {
          this.totalCounter.textContent = String(total);
        }

        /*
         * Tek medya varsa okları gizle.
         */
        const hideNavigation = total <= 1;

        if (this.prevButton) {
          this.prevButton.hidden = hideNavigation;
        }

        if (this.nextButton) {
          this.nextButton.hidden = hideNavigation;
        }
      }

      pauseCurrentMedia() {
        const activeMedia = this.querySelector(
          '.product-media-modal__content > [data-media-id].active'
        );

        if (!activeMedia) return;

        /*
         * Native video.
         */
        activeMedia.querySelectorAll('video').forEach((video) => {
          video.pause();
        });

        /*
         * YouTube / Vimeo iframe'ı yeniden yüklemeden
         * zorla kapatmıyoruz. Mevcut Dawn deferred-media
         * davranışını bozmamak için burada bırakıyoruz.
         */
      }
    }
  );
}